import { useState, type CSSProperties } from "react";
import { t } from "../i18n";
import { formatClock } from "../lib/format";

/**
 * Полоса перемотки. Пока палец на ползунке, показываем, куда тянут, а перематываем
 * по отпусканию: иначе каждое движение — новый запрос диапазона к серверу, и звук
 * заикается.
 */
export function Scrubber({
  currentTime,
  duration,
  onSeek,
  disabled = false,
}: {
  currentTime: number;
  duration: number;
  onSeek: (seconds: number) => void;
  disabled?: boolean;
}) {
  const [drag, setDrag] = useState<number | null>(null);
  const value = drag ?? currentTime;
  const max = duration > 0 ? duration : 1;
  const share = Math.min(100, Math.max(0, (value / max) * 100));
  const remaining = Math.max(0, duration - value);

  function commit() {
    if (drag === null) return;
    onSeek(drag);
    setDrag(null);
  }

  return (
    <div className="scrubber">
      <input
        type="range"
        className="scrubber__range"
        min={0}
        max={max}
        step={0.1}
        value={Math.min(value, max)}
        disabled={disabled || duration <= 0}
        onChange={(event) => setDrag(Number(event.target.value))}
        onPointerUp={commit}
        onTouchEnd={commit}
        onKeyUp={commit}
        onBlur={commit}
        aria-label={t("player.seek")}
        aria-valuetext={t("player.position", { current: formatClock(value), total: formatClock(duration) })}
        style={{ "--progress": `${share}%` } as CSSProperties}
      />
      <div className="scrubber__times" aria-hidden="true">
        <span>{formatClock(value)}</span>
        <span>-{formatClock(remaining)}</span>
      </div>
    </div>
  );
}
